import { environment } from '../environments/environment';

export interface IAppConfig {
  BaseUrl: string;
  ApiEndPoints: Object;
  Path: Object;
};

export class AppConfig implements IAppConfig {
  public loginUrl = `${environment.SITE_URL}entrar`;
  public BaseUrl = environment.API_URL;
  public Path = {
    partnership_own: 'Partnership_Owns',
    campaign_basics: 'Campaign_Basics',
    campaign_special: 'Campaign_Specials',
    companies: 'companies',
    cost_center: 'Cost_Centers',
    banners: 'Banners',
    addressTypes: 'addressTypes',
    company_addresses: 'Company_Addresses',
    company_reports: 'Company_Reports/company',
    metabase_company_report: 'metabase/company-report',
    establishments: 'Establishments',
    establishment_addresses: 'Establishment_Addresses',
    establishment_partnerships: 'Establishment_Partnership_Owns',
    establishment_favorites: 'EstablishmentFavorites',
    establishment: 'establishment',
    invite_logs: 'Invite_Logs',
    customers: 'Customers',
    employeeImports: 'EmployeeImports',
    accounts: 'Accounts',
    accountsPagination: 'Accounts/list/',
    categories: 'categories/active',
    storage: 'Storages',
    tagsHint: 'tagsHint',
    modality: 'establishment/modality',
    myEmployees: 'me/employees',
    myEmployee: 'me/employee',
    coupons: 'coupons',
    prize_draws: 'Prize_Draws',
    ticket_product: 'Ticket_Products',
    ticket_coupons: 'Ticket_Coupons',
    ticket_sales: 'Ticket_Sales',
    establishment_reports: 'Establishment_Reports',
    acceptance_terms: 'acceptance_terms',
    recaptcha: 'recaptcha',
    tokendirectlogins: 'tokendirectlogins',
    invite_members: 'invite_members',
    member_get_member_admin: 'member-get-member-admin',
    integration_viacep: 'integration-viacep',
    vouchers: 'vouchers',
    report_irregularities: 'report_irregularities',
    abastece99: 'abastece99',
    cashback: 'cashback',
    wallet: 'wallet'
  };
  public ApiEndPoints = {
    partnership_own: '/Partnership_Owns',
    getCategories: '/categories',
    findCnpj: '/findCnpj',
    modality_one: '/1',
    tagsHint: '/',
    findDocument: '/find/document',
    upload: '/colaboradores-dev/upload',
    saveImported: '/import/save',
    importEmployees: '/bulk_import',
    uploadImportEmployees: '/bulk_import/upload',
    bulkBlockEmployees: '/import/block',
    erroImport: '/bulk_import/errors',
    uploadBulkBlockEmployees: '/import/block/upload',
    createEmployee: '/bulk',
    updateEmployee: '/bulk',
    sendInvitationToUninvited: '/employees/invitation/uninvited',
    sendInvitationToAll: '/employees/invitation/all',
    sendInvitationAgain: '/employees/invitation/again',
    sendInvitation: '/employees/action/invite',
    searchFilters: '/searchFilters',
    blockEmployees: '/employees/action/block',
    unblockEmployees: '/employees/action/unblock',
    updateGroup: '/updateGroup',
    employeeExportPasswordConfirm: '/download/csv/passoword/confirm',
    employeeExport: '/download/csv',
    filters: '/establishment/listing/filters',
    ticketCouponsCount: '/count',
    exploreLocation: '/exploreLocation',
    login: '/login',
    getPlacesMetrics: '/getPlacesMetrics',
    getTopCompanies: '/getTopCompanies',
    getTopPartners: '/getTopPartners',
    getTopCategories: '/getTopCategories',

  };

  constructor() {
    this.ApiEndPoints[`${environment.BUCKET_UPLOAD_IMAGE}`] = `/${environment.BUCKET_UPLOAD_IMAGE}/upload-file`;
  }

}
